import { defaultFlow } from './defaultFlow';
import { segmentFlow } from './segmentFlow';
import { businessAnalysisFlow } from './businessAnalysisFlow';
import type { ChatFlowStrategy } from './types';

export type { ChatFlowStrategy, FlowContext } from './types';
export { executeFlow } from './executor';

/**
 * 按角色 schema 选请求策略，不看 agentRoleCode。
 *
 * - agent → /agent/resolve_async
 * - chat  → /chat/question/sql_data
 * - 其他  → 默认模式（sessionContinue → recommendQuestions）
 */
export const getChatFlowStrategy = (schema?: string): ChatFlowStrategy => {
  const kind = (schema ?? '').trim().toLowerCase();
  if (kind === 'agent') return businessAnalysisFlow;
  if (kind === 'chat') return segmentFlow;
  return defaultFlow;
};
